/* istanbul ignore file  */
import { env } from 'app/Env/env';
import { AxiosError } from 'axios';
import { IS_TEST_MODE } from 'consts';

const isEnv = (envName: string) => env.envName === envName;

export enum EnvName {
	PRODUCTION = 'production',
	SANDBOX = 'sandbox',
	LOCAL = 'local',
	TEST = 'test',
	PREVIEW = 'preview',
	PRIVATE_DEPLOYMENT = 'private_deployment'
}

export const isDescopeComProd = () => isEnv(EnvName.PRODUCTION);
export const isPrivateDeployment = () => isEnv(EnvName.PRIVATE_DEPLOYMENT);
export const isProductionEnv = () =>
	isDescopeComProd() || isPrivateDeployment();
export const isSandbox = () => isEnv(EnvName.SANDBOX);
export const isLocal = () => isEnv(EnvName.LOCAL);
export const isPreview = () => isEnv(EnvName.PREVIEW);
export const isTest = () => IS_TEST_MODE;

/* istanbul ignore next  */
export const getEnv = (): EnvName => {
	const { PRODUCTION, SANDBOX, LOCAL, PREVIEW, TEST } = EnvName;

	if (isProductionEnv()) {
		return PRODUCTION;
	}
	if (isSandbox()) {
		return SANDBOX;
	}
	if (isLocal()) {
		return LOCAL;
	}
	if (isPreview()) {
		return PREVIEW;
	}
	if (isTest()) {
		return TEST;
	}

	return PRODUCTION;
};

export const formatErrorResponseMessage = (
	errorMessage: string,
	res: AxiosError<any>
) => {
	let message = errorMessage;
	if (res.response?.data.errorDescription || res.response?.data.errorMessage) {
		message += ':';
		if (res.response?.data.errorDescription) {
			message += ' ';
			message += res.response.data.errorDescription;
		}
		if (res.response?.data.errorMessage) {
			message += ' ';
			message += res.response.data.errorMessage;
		}
	}
	return message;
};
